import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Button from '../buttons/Button';

import styles from '../../../styles/partials/contact-link.module.scss';

const propTypes = {
    link: AppPropTypes.contactLink.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ContactLink = ({ link, className }) => {
    const { title = null, label, type = 'email', value } = link;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
            <Button
                className={styles.bubble}
                href={`${type === 'email' ? 'mailto:' : 'tel:'}${value}`}
                rel="noreferrer"
                external
                target="_self"
            >
                <span className={styles.label}>{label}</span>
                <span className={styles.phoneEmail}>{value}</span>
            </Button>
        </div>
    );
};

ContactLink.propTypes = propTypes;
ContactLink.defaultProps = defaultProps;

export default ContactLink;
